import React, { useEffect, useState } from 'react';
import White from '../../assets/icons/popup/e-lotto-pcso-logo 1.svg?react';
import Withdraw from '../../assets/icons/Withdraw.svg?react';
import DepositPopupQR from './DepositPopupQR';
import WithdrawPopup from './WithdrawPopup';
import { QrCode } from 'lucide-react';
import { useWebSocket } from '../../context/WebSocketContext';

export default function WalletPopup({ isOpen, onClose, currentBalance }) {
  const [isVisible, setIsVisible] = useState(false); // To mount/unmount the popup
  const [isAnimating, setIsAnimating] = useState(false); // To control the animation
  const [showWithDraw, setShowWithDraw] = useState(false);
  const [showDepositQr, setShowDepositQr] = useState(false);
  const { resetPaymentStatus } = useWebSocket();

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true); // Mount the popup
      setTimeout(() => setIsAnimating(true), 10); // Add delay to trigger smooth animation
    } else {
      setIsAnimating(false); // Start closing animation
      const timer = setTimeout(() => setIsVisible(false), 300); // Unmount after animation
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible) return null;

  if (showDepositQr) {
    return (
      <DepositPopupQR
        isOpen={showDepositQr}
        onClose={() => setShowDepositQr(false)}
        currentBalance={currentBalance}
      />
    );
  }

  if (showWithDraw) {
    return (
      <WithdrawPopup
        isOpen={showWithDraw}
        onClose={() => setShowWithDraw(false)}
        currentBalance={currentBalance}
        defaultPaymentMethod={{
          type: 'GCASH',
          accountNumber: '09187914980',
        }}
      />
    );
  }

  const handleQrDepositClick = () => {
    resetPaymentStatus(); // Reset payment status before showing QR deposit
    setShowDepositQr(true);
  };

  return (
    <div
      className={`fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 transition-opacity duration-300 ${
        isAnimating ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div
        className={`relative w-full max-w-sm bg-white rounded-2xl transform transition-all duration-300 ease-in-out ${
          isAnimating ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        }`}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className='absolute right-3 top-3 text-gray-400 hover:text-gray-600 transition-colors z-10'
          aria-label='Close'
        >
          <svg
            className='w-5 h-5'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M6 18L18 6M6 6l12 12'
            />
          </svg>
        </button>

        {/* Header with logo */}
        <div className='pt-4'>
          <div className='flex items-center justify-center gap-2'>
            <White />
          </div>
        </div>

        {/* Action buttons */}
        <div className='p-4 space-y-3 text-base font-semibold'>
          <button
            onClick={handleQrDepositClick}
            className='w-full bg-[#0E64D1] hover:bg-blue-600 text-white py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2'
          >
            <QrCode color='#ffffff' /> QR DEPOSIT
          </button>
          <button
            onClick={() => setShowWithDraw(true)}
            className='w-full bg-[#CE1F28] hover:bg-red-600 text-white py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2'
          >
            <Withdraw />
            WITHDRAW
          </button>
        </div>
      </div>
    </div>
  );
}
